export default {
  setError: (state, error) => {
    state.error = error;
  },
};
